import { gray20, gray40opacity05 } from './../../../colors/gray';
export var MuiAccordion = {
    styleOverrides: {
        root: {
            '& [class*=MuiAccordionSummary-root]': {
                '&[class*=Mui-expanded]': {
                    '& [class*=MuiAccordionSummary-expandIcon]': {
                        color: gray20,
                    },
                },
                '& [class*=MuiAccordionSummary-content]': {
                    margin: 0,
                },
            },
        },
    },
    customOverrides: {
        filled: {
            '& [class*=MuiAccordionSummary-root]': {
                backgroundColor: gray40opacity05,
            },
        },
    },
};
